<template>
  <div class="math-processing-tab">
    <a-row type="flex" :gutter="10" class="filters">
      <a-col flex="1" style="height: 40px;">
          <input-enum class="white-date-picker" v-model="region" :options="regions" :allowClear="false" />
        </a-col>

        <a-col flex="1" style="max-width: 20vw; height: 40px;">
          <input-enum v-model="city" :options="cities" :allowClear="false" />
        </a-col>
      <a-col flex="1" style="height: 40px;">
          <input-enum
            v-model="classificator"
            :options="Object.keys(classificator_arr)"
            :allowClear="false"
          />
        </a-col>

        <a-col flex="1" style="height: 40px;">
          <input-enum
            v-model="category"
            :options="categories"
            :allowClear="false"
            @search="categorySearch"
          />
        </a-col>

      <a-col flex="1" style="height: 40px">
        <date-picker
            style="height: 40px;"
            label="Дата"
            :value="date"
            :enabledDatesArray="dates"
            format="YYYY-MM-DD"
            class="white-date-picker"
            @input="date = $event"
          />
      </a-col>
    </a-row>
    <a-row :gutter="10" type="flex">
      <a-col v-if="graphData" flex="2" style="display: flex">
        <div class="block-wrapper chart" style="width: 100%">
          <section style="width: 100%">
            <figure  style="width: 100%">
              <v-chart :option="bar" :init-options="initOptions" :loading="loading"  style="width: 900px; height: 400px;"/>
            </figure>
          </section>

<!--          <a-row class="filters" :gutter="70" type="flex">-->
<!--            <a-col>-->
<!--              <a-checkbox v-model="chart.control1" class="control-1" :value="1">-->
<!--                Контроль 1-->
<!--              </a-checkbox>-->
<!--            </a-col>-->

<!--            <a-col>-->
<!--              <a-checkbox v-model="chart.control2" class="control-2" :value="2">-->
<!--                Контроль 2-->
<!--              </a-checkbox>-->
<!--            </a-col>-->

<!--            <a-col>-->
<!--              <a-checkbox v-model="chart.control3" class="control-3" :value="3">-->
<!--                Контроль 3-->
<!--              </a-checkbox>-->
<!--            </a-col>-->
<!--          </a-row>-->
        </div>
      </a-col>

<!--      <a-col flex="1" style="display: flex">-->
<!--        <div class="block-wrapper descriptive">-->
<!--          <h3>Описательные статистики</h3>-->

<!--          <a-row type="flex" :gutter="[20, 60]">-->
<!--            <a-col flex="1">-->
<!--              <div>Среднее</div>-->

<!--              <div class="value-wrapper">0</div>-->
<!--            </a-col>-->

<!--            <a-col flex="1">-->
<!--              <div>Медиана</div>-->

<!--              <div class="value-wrapper">0</div>-->
<!--            </a-col>-->
<!--          </a-row>-->

<!--          <a-row type="flex" :gutter="[20, 60]">-->
<!--            <a-col flex="1">-->
<!--              <div>Минимум</div>-->

<!--              <div class="value-wrapper">0</div>-->
<!--            </a-col>-->

<!--            <a-col flex="1">-->
<!--              <div>Максимум</div>-->

<!--              <div class="value-wrapper">0</div>-->
<!--            </a-col>-->
<!--          </a-row>-->

<!--          <a-row type="flex" :gutter="[20, 60]">-->
<!--            <a-col flex="1">-->
<!--              <div>Дисперсия</div>-->

<!--              <div class="value-wrapper">0</div>-->
<!--            </a-col>-->

<!--            <a-col flex="1">-->
<!--              <div>Отсечено</div>-->

<!--              <div class="value-wrapper">0%</div>-->
<!--            </a-col>-->
<!--          </a-row>-->
<!--        </div>-->
<!--      </a-col>-->
    </a-row>
    <div class="block-wrapper">
      <math-processing-config :value="value" @input="setValue" />
    </div>
  </div>
</template>

<script>
import Tabs from '@/components/base/Tabs.vue';
import MathProcessingConfig from '@/components/math-processing/MathProcessingConfig';
import LineList from '@/components/base/LineList';
import DatePicker from "@/components/base/DatePicker.vue";
import {apolloClient} from "@/apolloClient";
import TABLE_QUERY from "@/queries/table";
import {bus, storage} from "@/helpers";
import InputEnum from '@/components/base/InputEnum.vue';
import axios from "axios";
import VChart from 'vue-echarts';

// import VChart from "../ECharts";
import { use } from "echarts/core";
import { BarChart } from "echarts/charts";
import { GridComponent, DatasetComponent, TooltipComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

use([ BarChart, GridComponent, DatasetComponent, CanvasRenderer, TooltipComponent ]);

const classificator_arr = { 'КИПЦ': 'kipc', 'ИПЦ': 'ipc', 'ОКПД2': 'okpd2' }

const apiUrl = process.env.VUE_APP_ROSSTAT_API_URL;
const esUrl = process.env.VUE_APP_ELASTIC_URL;

export default {
  name: 'MathProcessing',

  components: { LineList, MathProcessingConfig, Tabs, DatePicker, InputEnum, VChart },

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    bar: {},
    initOptions: {
      renderer: "canvas"
    },
    loading: true,
    classificator_arr,
    date: '',
    dates: [],
    categories: [],
    category: '',
    classificator: 'ИПЦ',
    category_search: '',
    regions: [],
    region: '',
    region_code_arr: [],
    cities: [],
    city: '',
    selected_okato: '',
    city_code_arr: [],
    graphData: []
    // chart: {
    //   control1: true,
    //   control2: true,
    //   control3: true,
    // },
  }),
  watch: {
    date() {
      storage.set('dateFilter', this.date)
      this.refetch();
    },
    category() {
      this.refetch();
    },
    classificator() {
      this.get_categories();
    },
    selected_okato() {
      this.refetch();
    },
    region() {
      this.get_cities();
    },
    city() {
      this.selected_okato = this.city_code_arr[this.city]
    },
    graphData() {
      this.bar = this.getData()
    }
  },
  created() {
    this.graphData  = []
    this.bar = this.getData()
    this.get_dates();
    this.get_regions();
    this.get_categories();
  },
  methods: {
    setValue(value) {
      this.$emit('input', { ...value });
    },
    categorySearch(value) {
      this.category_search = value
      this.get_categories()
    },
    async get_categories() {
      if (!this.classificator) return;
      const prevCategory = this.category;
      const client = apolloClient
        .query({
          ...TABLE_QUERY,
          variables: {
            type: 'FNSClassesConfiguration',
            page: 0,
            pageSize: 999,
            filters: [
              {
                field: `${this.classificator_arr[this.classificator]}Enabled`,
                value: 'true',
                operator: 'EQUALS',
              },
              {
                field: "name",
                value: this.category_search,
                operator: "ILIKE"
              }
            ],
          },
        })
        .catch((error) => {
          bus.$emit('error', {
            from: 'configFormLayout',
            description: `Ошибка получения конфига таблицы категорий`,
          });
          this.graphData = []
          throw error;
        });
      client.then((res) => {
        const arr = [];
        res.data.table.documents.forEach(({ data }) => {
          arr[data.name] = data[this.classificator_arr[this.classificator]];
        });
        const favorites = ['Картофель', "Морковь", 'Сметана'];
        this.categories = favorites.concat(
          Object.keys(arr)
            .sort()
            .filter((el) => !favorites.includes(el)),
        );
        if (!this.categories.includes(prevCategory)) {
          this.category = this.categories[0];
        }
      });
      this.category_search = ''
    },
    async get_regions() {
      const prevRegion = this.region;
      const client = apolloClient
        .query({
          ...TABLE_QUERY,
          variables: {
            type: 'Region',
            page: 0,
            pageSize: 10000,
          },
        })
        .catch((error) => {
          console.log(error);
          this.graphData = []
          bus.$emit('error', {
            from: 'configFormLayout',
            description: `Ошибка получения конфига таблицы регионов`,
          });
          throw error;
        });
      client.then((res) => {
        const arr = [];
        res.data.table.documents.forEach(({ data }) => {
          arr[data.name_region] = data.okato;
        });
        this.regions = Object.keys(arr);
        if (!this.regions.includes(prevRegion)) {
          this.region = this.regions[0];
          this.region = 'Москва';
        }
        this.region_code_arr = arr;
        this.get_cities();
      });
    },
    async get_cities() {
      if (!this.region && !this.date) return;
      const prevCity = this.city;
      await this.axios
        .get(
          `${apiUrl}/report/get_okato_list_for_region?region=${this.region_code_arr[this.region]}&date=${this.date}`
        )
        .then(({data}) => {
          if (!data.length) {
            this.graphData = []
          }
          Object.keys(data).forEach((key) => {
            while (data[key].slice(-1) === '0' && data[key].length > 2) {
              data[key] = data[key].slice(0, -1);
            }
          });
          this.cities = Object.keys(data);
          if (!this.cities.includes(prevCity)) {
            this.city = this.cities[0];
          }
          this.selected_okato = data[this.city];
          this.city_code_arr = data;
        });
    },
    async get_dates() {
      this.date = storage.get('dateFilter')
      const response = await this.axios.get(`${apiUrl}/report/get_date_v2`, {
        params: {
          type_report: 'identified',
        },
      });
      this.dates = response.data.sort().reverse();
      if (!this.date) {
        this.date = this.dates[0];
        storage.set('dateFilter', this.date)
      }
    },
    getData() {
      return {
        textStyle: {
          fontFamily: 'Inter, "Helvetica Neue", Arial, sans-serif'
        },
        dataset: {
          dimensions: ["Цена", "Количество"],
          source: this.graphData
        },
        xAxis: { type: "category" },
        yAxis: {},
        series: [{ type: "bar" }],
        tooltip: {
          show: true,
          trigger: 'item'
        }
      };
    },
    async refetch() {
      if (!this.date || !this.category || !this.selected_okato) {
        return;
      }
      this.loading = true
      this.graphData  = []
      const dataRequest = axios.CancelToken.source();
      const query = {
        "query": {
          "bool": {
            "must": [
              {
                "bool": {
                  "should": [
                    {
                      "wildcard": {
                        "ОКАТО": {
                          "value": `${this.selected_okato}*`
                        }
                      }
                    },
                    {
                      "wildcard": {
                        "Товар представитель.keyword": {
                          "value": `${this.category}`
                        }
                      }
                    }
                  ],
                  "minimum_should_match": 2
                }
              }
            ]
          }
        },
        "aggs": {
          "price": {
            "terms": {
              "field": "Цена за требуемую упаковку",
              "size": 100000
            },
            "aggs": {
              "round_price": {
                "avg": {
                  "field": "Цена за требуемую упаковку"
                }
              },
              "rounded_avg": {
                "bucket_script": {
                  "buckets_path": {
                    "round_price": "round_price"
                  },
                  "script": "(Math.round(params.round_price)/10)*10"
                }
              }
            }
          }
        },
        "size": 0
      }
      await this.axios
        .post(`${esUrl}/identified_${this.date}/_search?pretty`, query, {
          cancelToken: dataRequest.token
        })
        .then(({data}) => {
          let total= {}
          if (data.aggregations.price.buckets.length) {
            const arr = data.aggregations.price.buckets.map((el) => ({
              count: el.doc_count,
              price: el.rounded_avg.value
            }))
            arr.forEach((el) => {
              if (Object.keys(total).includes(String(el.price))) {
                total[el.price] += el.count
              } else {
                total[el.price] = el.count
              }
            })
            this.graphData = Object.keys(total).map((el) => ({
              'Цена': el,
              'Количество': total[el],
            }))
          }
        })
      .catch((err)=>{
        this.graphData = []
        this.$notification.error({
            message: `Не удалось загрузить данные. Обратитесь к администратору.`,
          });
        throw err;
      })
      .finally(()=>{
        this.bar = this.getData();
        this.loading = false
      })

    }
  },
};
</script>

<style lang="scss">
.math-processing-tab {
  .tabs {
    &__switch-list {
      width: 100%;
      height: 40px;
      line-height: 30px;
      background: #fff !important;
      display: flex;
    }

    &__switch {
      flex: 1 1 auto;
      text-align: center;
      white-space: nowrap;

      &--active {
        background: #cdd7e4;
      }
    }
  }

  .filters {
    & > * {
      margin-bottom: 10px;
    }
  }

  .chart {
    $chart-color-1: #e76464;
    $chart-color-2: #e2bd38;
    $chart-color-3: #529aff;

    .filters {
      margin-top: 20px;

      .control-1 {
        .ant-checkbox-inner {
          background-color: transparent;
          border-color: $chart-color-1;
        }

        .ant-checkbox-checked {
          background-color: $chart-color-1;
        }
      }

      .control-2 {
        .ant-checkbox-inner {
          background-color: transparent;
          border-color: $chart-color-2;
        }

        .ant-checkbox-checked {
          background-color: $chart-color-2;
        }
      }

      .control-3 {
        .ant-checkbox-inner {
          background-color: transparent;
          border-color: $chart-color-3;
        }

        .ant-checkbox-checked {
          background-color: $chart-color-3;
        }
      }
    }
  }

  .descriptive {
    width: 100%;

    .ant-input-number {
      width: 100%;
    }

    .value-wrapper {
      background: #e4eaf4;
      padding: 10px;
      border-radius: 6px;
    }
  }
}
</style>
